import { memo } from "react";
import { useParams } from "react-router-dom";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESCheckbox } from "@app/shared/qes-standards/forms/Checkbox";
import { ProviderNetworkVersionSelect } from "@app/provider-network-imports/components/ProviderNetworkVersionSelect";
import { useImportConfig, useImportSaga, useImportResults } from "@app/provider-network-imports/hooks";

function nonMemoProviderNetworkImportInfoPanel() {
  const { versionId, networkId } = useParams<{ networkId?: string, versionId?: string }>();
  const { hasConfiguredGroups, toggleAutoActivate, toggleAutoComplete, toggleAutoRun, settings } = useImportConfig();
  const { saga } = useImportSaga();
  const { exportResultsAsExcel } = useImportResults();

  return (
    <div className="d-flex flex-row justify-content-between pb-2">
      <div className="d-flex flex-column">
        <span>Provider Network Id: {networkId}</span>
        <span>VersionId: {versionId}</span>
        <span>Provider Import Source: {saga.providerSource ? saga.providerSource : "No Data"}</span>
        <QESCheckbox
          label="Auto Complete"
          id="AutoComplete-switch"
          checked={settings.autoComplete}
          onChange={toggleAutoComplete}
          aria-label="Toggle Auto Complete"
          testId="network-import__auto-complete"
        />
        <QESCheckbox
          label="Auto Activate"
          id="AutoActivate-switch"
          checked={settings.autoActivate}
          onChange={toggleAutoActivate}
          aria-label="Toggle Auto Activate"
          testId="network-import__auto-activate"
        />
        <QESCheckbox
          label="Auto Run"
          id="AutoRun-switch"
          checked={settings.autoRun}
          onChange={toggleAutoRun}
          aria-label="Toggle Auto Run"
          testId="network-import__auto-run"
        />
      </div>
      <div className="d-flex flex-column justify-content-end pb-2">
        <ProviderNetworkVersionSelect />
        <QESButton qesTestId="provider-network-import-info-panel" qesType="secondary" onClick={() => exportResultsAsExcel(+versionId)} disabled={!saga.correlationId || !saga.providerSource || !hasConfiguredGroups()} className="mt-2 align-self-end">Export Excel</QESButton>
      </div>
    </div>
  );
}

export const ProviderNetworkImportInfoPanel = memo(nonMemoProviderNetworkImportInfoPanel);
